import { apiClient } from "../config";

async function deleteAccountRequest() {
  const res = await apiClient.delete(`/admin/delete-account-request`);
  return res.data;
}

export default deleteAccountRequest;
